import { getTemplate } from "../template-helper";
import { translateElement, tr } from "../../util/locales" ;
import { waiter } from "../../util/utils";
import { save, update, runInContext } from "../binding";
import { error } from "../../util/dialogs";

const COMPONENT_NAME = "z-button-save" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonSaveComponent extends HTMLElement {
            constructor() {
                super();
                this.button = this.querySelector("button") ;
                if(!this.button){
                    const innerHtml = this.innerHTML ;
                    this.innerHTML = "" ;
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    translateElement(this) ;
                    this.button = this.querySelector("button") ;
                    if(innerHtml){
                        this.button.innerHTML = innerHtml ;
                    }
                    if(this.className.includes("btn")){
                        this.button.className = this.className ;
                        this.className = "" ;
                    }
                }

                
                this.addEventListener("click", ()=>{
                    this.onSave() ;
                }) ;
            }

            get disabled() {
                return this.button.getAttribute("disabled") ;
            }
            
            set disabled(disabled) {
                this.button.setAttribute("disabled", disabled) ;
            }

            static get observedAttributes() {
                return ['disabled'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'disabled':
                        this.disabled = newValue ;
                    break;
                }
            }

            onSave(){
                if(!this.form){
                    this.form = this.closest("form");
                }
                if(!this.form){ throw "Button save should be inside a form" ; }

                let fieldId = "id" ;
                if(this.hasAttribute("z-field-id")){
                    fieldId = this.getAttribute("z-field-id") ;
                }

                this.form.dispatchEvent(new Event("beforeSave")) ;

                waiter(this.checkForm()).then((validationErrors)=>{
                    const feedbackEl = this.form.querySelector("z-error-feedback") ;
                    if(feedbackEl){
                        feedbackEl.value = "" ;
                    }
                    if(validationErrors.length>0){
                        if(feedbackEl){
                            feedbackEl.value = validationErrors.map(function(e){ return "<p>"+e.msg+"</p>" ;}).join("") ;
                        }else{
                            error(validationErrors.map(function(e){ return "<p>"+e.msg+"</p>" ;}).join("")) ;
                        }
                    }else{
                        waiter(
                            save(this.form, fieldId).then((savedRecord)=>{
                                return new Promise((resolve, reject)=>{
                                    let afterSaveAttr = this.getAttribute("z-after-save") ;
                                    if(afterSaveAttr){
                                        const afterSaveObj = runInContext(this, {savedRecord}, afterSaveAttr) ;
                                        if(typeof(afterSaveObj) === "object" && afterSaveObj.constructor === Promise){
                                            //the result is a promise, wait for it to resolve !
                                            return afterSaveObj.then(resolve).catch(reject) ;
                                        }else{
                                            return resolve() ;
                                        }
                                    }

                                    let nextUrl = this.getAttribute("z-next-url") ;
                                    if(nextUrl){
                                        let functionNextUrl = this[nextUrl] ;
                                        if(!functionNextUrl){
                                            functionNextUrl = this.form[nextUrl] ;
                                        }
                                        if(!functionNextUrl){
                                            const zForm = this.closest("z-form");
                                            if(zForm){
                                                functionNextUrl = zForm[nextUrl] ;
                                            }
                                        }
                                        if(functionNextUrl){
                                            //this is a function 
                                            let afterSaveObj = functionNextUrl(savedRecord) ;
                                            if(afterSaveObj){
                                                if(typeof(afterSaveObj) === "string"){
                                                    //the result is a string, use it
                                                    return resolve(afterSaveObj) ;
                                                }else if(typeof(afterSaveObj) === "object" && afterSaveObj.constructor === Promise){
                                                    //the result is a promise, wait for it to resolve !
                                                    return afterSaveObj.then(resolve).catch(reject) ;
                                                }
                                            }else{
                                                resolve() ;
                                            }
                                        }else{
                                            resolve(nextUrl.replace("{{id}}", savedRecord[fieldId])) ;
                                        }
                                    }else{
                                        resolve(window.location.href
                                            .replace(/\/modify\//, "/read/")
                                            .replace(/\/create/, "/read/"+savedRecord[fieldId])
                                        ) ;
                                    }
                                }) ;
                            }).catch((err)=>{
                                console.log(err) ;
                                let errMsg = err;
                                if(err.name){
                                    errMsg = err.name;
                                }
                                const trKey = "error."+errMsg ;
                                const trMsg = tr(trKey) ;
                                if(trMsg !== trKey){
                                    errMsg = trMsg;
                                }
                                if(this.errorHandler){
                                    errMsg = this.errorHandler(err) ;
                                }
                                if(feedbackEl){
                                    feedbackEl.value = errMsg;
                                }else{
                                    error(errMsg) ;
                                }
                            })
                        ).then((nextUrl)=>{
                            if(nextUrl && nextUrl !== "none"){
                                window.location.href = nextUrl ;
                            }
                        }) ;
                    }
                }) ;

            }

            checkForm(){
                let form = this.form ;
                let validations = this.form.validations || [];
                form.classList.add("was-validated") ;
    
                let errors = [] ;
                let promises = [] ;
                validations.forEach((validation)=>{
                    let data = form.__zzBindData ;
                    if(!data){
                        data = {} ;
                        update(form, data) ;
                    }
                    let validationResult = validation({ form: form, data: data, tr: tr }) ;
                    if(validationResult && typeof(validationResult) && validationResult.constructor === Promise){
                        promises = validationResult ;
                    }else{
                        promises.push(new Promise((resolve/*, reject*/)=>{
                            return resolve(validationResult) ;
                        })) ;
                    }
                });
                return Promise.all(promises).then((results)=>{
                    results.forEach((result)=>{
                        let detectedErrors = result;
                        if(!detectedErrors){ detectedErrors = [] ;}
                        if(detectedErrors && !Array.isArray(detectedErrors)){
                            detectedErrors = [detectedErrors];
                        }
                        detectedErrors.forEach(function(e, i){
                            if(typeof(e) === "string"){
                                detectedErrors[i]= {msg : e} ;
                            }
                        }) ;
                        errors = errors.concat(detectedErrors||[]) ;
                    }) ;
    
                    let invalidFields = form.querySelectorAll(":invalid") ;
                    for(let i=0; i<invalidFields.length; i++){
                        const invalidEl = invalidFields[i] ;
                        if(invalidEl.manualInvalid){
                            delete invalidEl.manualInvalid ;
                            invalidEl.setCustomValidity("");
                        }
                    }
    
                    let globalErrors = [] ;
                    for(let i=0; i<errors.length; i++){
                        const error = errors[i] ;
                        if(error.field){
                            var elInput = form.querySelector('[z-bind="'+error.field+'"]') ;
                            if(elInput){
                                elInput.setCustomValidity(error.msg);
                                elInput.manualInvalid = true ;
                            }else{
                                globalErrors.push(error) ;
                            }
                        }else{
                            globalErrors.push(error) ;
                        }
                    }
    
                    /*var formValidity = */form.checkValidity() ;
    
                    invalidFields = form.querySelectorAll(":invalid") ;
                    for(let i=0; i<invalidFields.length; i++){
                        const invalidEl = invalidFields[i] ;
                        const message = invalidEl.validationMessage ;
                        if(message){
                            let parentEl = invalidEl.closest(".form-group")||invalidEl ;
                            let feedbackEl = parentEl.querySelector(".invalid-feedback") ;
                            if(feedbackEl){
                                feedbackEl.innerHTML = message ;
                            }
                            let labelEl = parentEl.querySelector("label") ;
                            let label = "" ;
                            if(labelEl){
                                label = labelEl.innerHTML;
                            }
                            globalErrors.push({
                                el: parentEl,
                                field: invalidEl.getAttribute("z-bind"),
                                label: label,
                                msg: (label?label+" : ":"")+message
                            }) ;
                        }
                    }
                    
                    if(globalErrors.length === 0){
                        form.classList.remove("was-validated") ;
                    }

                    return Promise.resolve(globalErrors) ;
                }) ;
            }

        }
        customElements.define(COMPONENT_NAME, ButtonSaveComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
